export const BUYER_GATEWAY_RAW_MARKER_INTENT = 'buyer_gateway_outbound_handoff';
export const BUYER_GATEWAY_SETTLEMENT_SNAPSHOT_SOURCE = 'buyer_gateway_app_validated_settlement';
export const BUYER_GATEWAY_SETTLEMENT_SNAPSHOT_STATUS = 'public_home_settled';
export const BUYER_GATEWAY_AUTHORIZED_TARGET_HOSTS = Object.freeze([
  'buyer.cassavachain.com',
  'www.buyer.cassavachain.com',
]);

export function normalizeBuyerGatewayEpoch(value) {
  if (typeof value !== 'number') return 0;
  const epoch = value;
  return Number.isFinite(epoch) && epoch > 0 ? epoch : 0;
}

function normalizeTime(value) {
  if (typeof value !== 'number') return 0;
  const time = value;
  return Number.isFinite(time) && time > 0 ? time : 0;
}

function normalizeBuyerGatewayOutboundNonce(value) {
  if (typeof value !== 'string') return '';
  const nonce = value.trim();
  return nonce && nonce.length <= 80 ? nonce : '';
}

function markerPayload(marker) {
  return marker?.handoff && typeof marker.handoff === 'object' ? marker.handoff : marker;
}

export function isFreshBuyerGatewayOutboundSignal({ marker = null, now = 0, currentEpoch = 0, allowBootstrapRebind = false, ttlMs = 15 * 60 * 1000 } = {}) {
  const payload = markerPayload(marker);
  if (!payload || typeof payload !== 'object') return false;
  const observedAt = normalizeTime(now);
  const startedAt = normalizeTime(payload.startedAt || payload.createdAt || payload.at);
  const expiresAt = normalizeTime(payload.expiresAt);
  const nonce = normalizeBuyerGatewayOutboundNonce(payload.nonce);
  if (String(payload.intent || '') !== BUYER_GATEWAY_RAW_MARKER_INTENT) return false;
  if (!BUYER_GATEWAY_AUTHORIZED_TARGET_HOSTS.includes(String(payload.targetHost || '').toLowerCase())) return false;
  if (!nonce) return false;
  if (!observedAt || !startedAt || observedAt < startedAt) return false;
  if (observedAt - startedAt > Number(ttlMs || 15 * 60 * 1000)) return false;
  if (expiresAt && observedAt > expiresAt) return false;
  const markerEpoch = normalizeBuyerGatewayEpoch(payload.runtimeEpoch);
  const activeEpoch = normalizeBuyerGatewayEpoch(currentEpoch);
  if (!markerEpoch || !activeEpoch) return !!allowBootstrapRebind;
  return markerEpoch === activeEpoch || !!allowBootstrapRebind;
}

export function isValidBuyerGatewaySettlementSnapshot({ snapshot = null, currentEpoch = 0, now = 0, ttlMs = 30 * 1000 } = {}) {
  if (!snapshot || typeof snapshot !== 'object') return false;
  const epoch = normalizeBuyerGatewayEpoch(currentEpoch);
  const snapshotEpoch = normalizeBuyerGatewayEpoch(snapshot.runtimeEpoch || snapshot.epoch);
  const settledAt = normalizeTime(snapshot.settledAt || snapshot.at || snapshot.createdAt);
  const observedAt = normalizeTime(now);
  const expiresAt = normalizeTime(snapshot.expiresAt);
  const status = String(snapshot.settlementStatus || snapshot.status || '');
  return !!(
    epoch && snapshotEpoch === epoch && settledAt && observedAt >= settledAt &&
    expiresAt && expiresAt >= settledAt && observedAt <= expiresAt &&
    expiresAt - settledAt <= Number(ttlMs) &&
    observedAt - settledAt <= Number(ttlMs) &&
    status === BUYER_GATEWAY_SETTLEMENT_SNAPSHOT_STATUS &&
    String(snapshot.source || '') === BUYER_GATEWAY_SETTLEMENT_SNAPSHOT_SOURCE
  );
}
